<script lang="ts">
import { link } from 'svelte-spa-router'
import { _ } from '../i18n.svelte'

import MessageCard from '../components/messageCard.svelte';
import LanguageImg from '../components/languageImg.svelte';
</script>
<template lang="pug">
main
    section
        .container.container-kv
            h1.top-kv__site-title__text {_('page_title', 'You can [***] on this site.')}
            .top-kv__site-title-hash__text \#{_('page_title_hash', 'ca19c25d2b72939920f311869f1f5afa')}
            .top-kv__buttons__area
                a.top-kv__buttons-button__wrapper.--generate.__hover-opacity__0-5(
                    href="/generate"
                    use:link
                )
                    | 作成する
                a.top-kv__buttons-button__wrapper.--resolve.__hover-opacity__0-5(
                    href="{_('page_title_resolve_utl', '/resolve')}"
                    use:link
                )
                    | 確認する
                a.top-kv__buttons-button__wrapper.--answer.__hover-opacity__0-5(
                    href="{_('page_title_answer_url', '/answer')}"
                    use:link
                )
                    | 照会する
            .top-kv__arrow__img
                LanguageImg(alt_ja="arrow" alt="arrow" src_ja="/img/arrow2.png" src_en="/img/arrow2_en.png")
    section.section-kv
        .container.container-overview
            .top-orverview__message__wrapper
                p.top-orverview__message-text__text
                    | 隠したい部分を伏字にした
                    r.sp
                    | 秘密のテキストを作るアプリです。
                p.top-orverview__message-text__text
                    | メッセージを入力すると、隠しておきたい部分は伏字に変換して、
                    br
                    | 元のメッセージから算出したハッシュ値を添付します。
                p.top-orverview__message-text__text
                    | 秘密を公表する際は、このハッシュ値を元に、
                    br
                    | 隠していた部分が正しいことを証明することができます。
                p.top-orverview__message-text__text.pc
                    | 元のメッセージが分かると、ハッシュ値は一定の方法で算出できるため、
                    br
                    | 不正はできず、本アプリが消滅しても安心です。
            .top-overview__sample__wrapper
                .top-overview__sample-message__text
                    | たとえばこんな[***]のメッセージを作成できます。
                    br
                    | ↓ これがハッシュ値です。
                .top-overview__sample-hash__text
                    | #3d3a82020328353ef958294cdce62535

    section
        .container.container-start
            a.top-start__buttons-button__wrapper.__hover-opacity__0-5(
                href="/generate/"
                use:link
            )
                | 秘密を作る！
            .top-start__arrow__img
                LanguageImg(alt_ja="arrow" alt="arrow" src_ja="/img/arrow.png" src_en="/img/arrow_en.png")

    section.section-use
        .container.container-use
            .top-use__section-title__text 使い道
            .top-use__how-use__area
                .top-use__how-use-title__text
                    | 1. まだ秘密だけど宣言しておきたいことがあるとき。
                .top-use__how-use-description__text
                    | まだ公開前情報だったり、お楽しみを残しておきたいときに、ギリギリ報告できるところまでをお知らせすることができます。
                    | ただし守秘義務は守ってくださいね！
                .top-use__sample__wrapper
                   .top-use__sample-message__text
                        | 来月[***]さんとコラボします！
                   .top-use__sample-hash__text
                        | #7a5be2e1865aa5f20dd0e9116ba2b31f
            .top-use__how-use__area
                .top-use__how-use-title__text
                    | 2. 予言をしたいとき。
                .top-use__how-use-description__text
                    | 本物の予言者でも、事が起こってから後出しで発表していては証明できません。とはいえ事前に予言を公開してしまうと未来が変わってしまうかもしれない。
                    | 本アプリを使えば内容は秘密のまま予言を宣言をすることができるので、本物の予言者ということを簡単に証明できます！
                .top-use__sample__wrapper
                   .top-use__sample-message__text
                        | 2100年、世界は[***]を迎えます。
                   .top-use__sample-hash__text
                        | #c47e773745c3d72a163c5e8f1cd36075
            
            .top-use__how-use__area
                .top-use__how-use-title__text
                    | 3. ちょっとしたクイズを出したいとき。
                .top-use__how-use-description__text
                    | クイズの答えを秘密にすれば、答えの確認も簡単！
                .top-use__sample__wrapper
                   .top-use__sample-message__text
                        | 生命、宇宙、そして万物についての究極の疑問の答え = [***]
                   .top-use__sample-hash__text
                        | #eb331b885b2e46947f582f874a08cf05

    section.section-howto
        .container.container-howto
            .top-howto__section-title__text 使い方
            .top-howto__section-sub-title__text 秘密のメッセージを作る
            ol.top-howto__howto-list__wrapper
                li.top-howto__howto-list-item__wrapper
                    a(href="/generate" use:link) メッセージ入力画面
                    | にアクセスします。
                li.top-howto__howto-list-item__wrapper テキストボックスにメッセージを入力します。
                li.top-howto__howto-list-item__wrapper 秘密にしたい部分を [ ] で囲みます。
                li.top-howto__howto-list-item__wrapper メッセージ内容を確認する際に使う合言葉を入力します。
                li.top-howto__howto-list-item__wrapper メッセージをシェアします。
                li.top-howto__howto-list-item__wrapper 完了！
            .top-howto__section-sub-title__text 秘密のメッセージを確認する
            ol.top-howto__howto-list__wrapper
                li.top-howto__howto-list-item__wrapper
                    a(href="/resolve" use:link) メッセージ確認画面
                    | にアクセスします。
                li.top-howto__howto-list-item__wrapper 伏字になっている部分に対応する文字列を入力します。
                li.top-howto__howto-list-item__wrapper 合言葉を入力します。
                li.top-howto__howto-list-item__wrapper 伏字に対応する文字と合言葉があっていたら元のメッセージと同一ということが確認できます。
                li.top-howto__howto-list-item__wrapper 完了！
            .top-howto__section-sub-title__text 答えを確認する
            ol.top-howto__howto-list__wrapper
                li.top-howto__howto-list-item__wrapper 答えページのURLをメッセージ作成者に確認します。
                li.top-howto__howto-list-item__wrapper 答えページにアクセスします。
                li.top-howto__howto-list-item__wrapper 答えを確認します。
                li.top-howto__howto-list-item__wrapper 完了！
    section.section-hash
        .container.container-hash
            .top-hash__section-title__text ハッシュ値とは？
            p
                | ハッシュ値とは、元データからハッシュ関数(
                a.top-hash__section-message-link__text(href="https://en.wikipedia.org/wiki/MD5" target="_blank" rel="noopener") MD5
                | )と呼ばれる計算手順により求められた、固定の桁数の値のことをいいます。
                | ハッシュ値は元のデータが１か所でも違うと計算されるハッシュ値が全く違うものになるという特徴があります。
                | またハッシュ値は不可逆であり、ハッシュ値から元のデータを復元することは実質不可能です。

    section
        .container.container-start
            a.top-start__buttons-button__wrapper.__hover-opacity__0-5(
                href="/generate/"
                use:link
            )
                | 秘密を作る！
            .top-start__arrow__img
                LanguageImg(alt_ja="arrow" alt="arrow" src_ja="/img/arrow.png" src_en="/img/arrow_en.png")
</template>
<style lang="scss">
.container-kv {
    width: 100%;
    padding: 10rem 0;
    position: relative;
    text-align: center;
    @media screen and (max-width:480px) {
        padding: 10rem 0 13rem;
    }
    .top-kv__site-title__text {
        font-size: 2.5rem;
    }
    .top-kv__site-title-hash__text {
        font-size: 1rem;
    }
    .top-kv__buttons__area {
        width: 100%;
        margin: 5% 0 0;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 5%;
        @media screen and (max-width: 480px) {
            display: flex;
            flex-direction: column;
        }
    }
    .top-kv__buttons-button__wrapper {
        padding: 1rem 3rem;
        text-align: center;
        color: #ffffff;
        text-decoration: none;
        &.--generate {
            color: var(--color-twitter);
            border-bottom: 2px solid var(--color-twitter);
        }
        &.--resolve {
            color: var(--color-orange);
            border-bottom: 2px solid var(--color-orange);
        }
        &.--answer {
            color: var(--color-green);
            border-bottom: 2px solid var(--color-green);
        }
        @media screen and (max-width: 480px) {
            margin: 2rem 0 0;
            padding: 1rem 6rem;
        }
    }
    .top-kv__arrow__img {
        width: 15rem;
        position: absolute;
        bottom: 3rem;
        left: 50%;
        opacity: .2;
        @media screen and (max-width:480px) {
            width: 20rem;
            bottom: 6.3rem;
            left: 42%;
            transform: rotate(-33deg);
        }
    }
}
.section-kv {
    color: var(--color-white);
    background-color: var(--color-twitter);
    .container-overview {
        padding: 3rem 0;
        .top-orverview__message__wrapper {
            .top-orverview__message-text__text {
                font-size: 1rem;
                text-align: center;
                line-height: 2;
                &:nth-child(1) {
                    font-size: 1.4rem;
                    font-weight: bold;
                }
                &:nth-child(2) {
                    margin: 2rem 0 0;
                }
            }
        }
        .top-overview__sample__wrapper {
            width: 100%;
            max-width: 37rem;
            margin: 1rem auto 0;
            padding: 2rem 4rem;
            border: 1px solid var(--color-border-line);
            border-radius: 10px;
        }
    }
}
.section-use {
    color: var(--color-white);
    background-color: var(--color-green);
    .container-use {
        padding: 3rem 1rem;
        .top-use__section-title__text {
            font-size: 1.5rem;
            font-weight: bold;
        }
        .top-use__how-use-title__text {
            margin: 1rem 0 0;
            font-size: 1.1rem;
            font-weight: bold;
        }
        .top-use__sample__wrapper {
            width: 100%;
            max-width: 37rem;
            margin: 1rem auto 0;
            padding: 2rem 4rem;
            border: 1px solid var(--color-border-line);
            border-radius: 10px;
            .top-use__sample-message__text {
                font-weight: bold;
            }
        }
    }
}
.section-howto {
    .container-howto {
        color: var(--color-black);
        padding: 3rem 2rem;
        .top-howto__section-title__text {
            font-size: 1.5rem;
            font-weight: bold;
        }
        .top-howto__section-sub-title__text {
            margin: 1rem 0 0;
            font-size: 1rem;
            font-weight: bold;
        }
        .top-howto__howto-list__wrapper {
            font-size: 0.8rem;
            .top-howto__howto-list-item__wrapper {
                margin: .5rem 0 0;
            }
        }
    }
}
.section-hash {
    color: var(--color-white);
    background-color: var(--color-black);
    .container-hash {
        padding: 3rem 1rem;
        .top-hash__section-title__text {
            font-size: 1.5rem;
            font-weight: bold;
        }
        .top-hash__section-message-link__text {
            color: var(--color-white);
        }
    }
}
.container-start {
    position: relative;
    text-align: center;
    padding: 9rem 0 3rem;
    .top-start__buttons-button__wrapper {
        padding: 10px 8%;
        text-align: center;
        color: var(--color-twitter);
        text-decoration: none;
        border-bottom: 2px solid var(--color-twitter);
    }
    .top-start__arrow__img {
        width: 15rem;
        position: absolute;
        top: 3rem;
        left: 35%;
        opacity: .2;
    }
}
</style>
